'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceType = void 0;
var DeviceType;
(function (DeviceType) {
    DeviceType["DESKTOP"] = "Desktop";
    DeviceType["MOBILE"] = "Mobile";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
